export const CacheKeys = {
    summary:      [ "summary"      ] as const,
    providers:    [ "providers"    ] as const,
    compliances:  [ "compliances"  ] as const,    
    
    documents:    [ "documents" ] as const,
    
    categories:   [ "categories"] as const,    
    
    tags: (categoryId: number) =>
        [ "categories", `${categoryId}`, "tags"] as const,
    
    requirements: (categoryId: number, tagId: number) => 
        [ "categories", `${categoryId}`, "tags", `${tagId}`, "requirements"] as const,
}